import { Collapse } from 'antd';
import parse from 'html-react-parser';
import React, { useState } from 'react';
import { BsDash } from 'react-icons/bs';
import LinkButton from '../../../common/LinkButton';
import ContactUsModal from '../modal/ContactUs';
import { Deal, FAQ } from '../redux/types';

const { Panel } = Collapse;

type Props = {
    faq: FAQ[];
    deal?: Deal;
};

const DealFAQ: React.FC<Props> = ({ faq, deal }) => {
    const [open, setOpen] = useState(false);
    const customExpandIcon = (panelProps: { isActive?: boolean; onTrigger?: () => void }) => {
        const iconClasses = `custom-collapse-icon transition-transform duration-300 ease-in-out ${
            panelProps.isActive ? 'rotate-90' : ''
        }`;
        return (
            <span className={iconClasses} onClick={panelProps.onTrigger}>
                {panelProps.isActive ? <BsDash size={'2rem'} className="rotate-90" /> : <BsDash size={'2rem'} />}
            </span>
        );
    };
    return (
        <div>
            <ContactUsModal deal={deal} open={open} setOpen={setOpen} />
            <p className="text-[#142C53] text-2xl font-[WorkSans-Semibold] uppercase font-bold common_read_title mt-6">
                FAQ
            </p>

            <Collapse
                expandIcon={customExpandIcon}
                bordered={false}
                className="deal_faq bg-white"
                expandIconPosition="end"
            >
                {faq.map((f, index) => (
                    <Panel
                        header={
                            <div className="flex gap-1 font-[Lato] text-sm">
                                {/* <p className="mr-2">{String(index + 1).padStart(2, '0')}</p> */}
                                <span className="">{f.question}</span>
                            </div>
                        }
                        key={`${f.uuid}_${index}`}
                    >
                        <div className="font-[Lato] text-[#152C52]"> {parse(f.answer)}</div>
                    </Panel>
                ))}
            </Collapse>

            <div className="mt-6">
                <div className="bg-[#F1F7FF] px-4 py-3 flex justify-between items-center">
                    <p className="text-[#20222B] font-[WorkSans] text-base">Have more questions?</p>
                    <LinkButton title="Contact Us" isArrow={true} onClick={() => setOpen(!open)} />
                </div>
            </div>
        </div>
    );
};

export default DealFAQ;
